<template>
  <div class="pia-chatbot">
    <v-card v-if="chatbotOpen" class="pia-window" role="dialog" aria-label="Chat de suporte PIA">
      <div class="pia-header">
        <div class="pia-identity">
          <div class="pia-avatar pia-avatar--header" aria-hidden="true">
            <img src="../../assets/logo-pia.png" alt="" class="pia-logo">
          </div>
          <div>
            <strong>PIA <span class="pia-online-dot"></span></strong>
            <small>PetroSupply Inteligência Artificial</small>
          </div>
        </div>
        <div class="pia-header-actions">
          <v-btn icon dark small type="button" aria-label="Minimizar chat" @click="closeChat">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
          <v-btn icon dark small type="button" aria-label="Fechar chat" @click="closeChat">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <div ref="messages" class="pia-messages" aria-live="polite">
        <div v-for="message in messages" :key="message.id" :class="['pia-message-row', `pia-message-row--${message.sender}`]">
          <div :class="['pia-message', `pia-message--${message.sender}`]">
            <strong v-if="message.title" class="pia-message-title">{{ message.title }}</strong>
            <p v-for="paragraph in message.paragraphs" :key="paragraph">{{ paragraph }}</p>
            <ul v-if="message.list" class="pia-message-list">
              <li v-for="item in message.list" :key="item">{{ item }}</li>
            </ul>
            <div v-if="message.alert" class="pia-alert">
              <v-icon small color="#8a6500" class="mr-1">mdi-shield-check-outline</v-icon>
              {{ message.alert }}
            </div>
            <div v-if="message.actions" class="pia-actions">
              <v-btn
                v-for="action in message.actions"
                :key="action.label"
                outlined
                small
                type="button"
                class="pia-action"
                @click="runAction(action.action)">
                {{ action.label }}
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <div class="pia-composer">
        <div class="pia-security-note">
          <v-icon x-small color="#167ABC" class="mr-1">mdi-lock-outline</v-icon>
          Não informe senhas ou códigos de acesso.
        </div>
        <form class="pia-input-row" @submit.prevent="sendMessage">
          <v-text-field
            v-model="draftMessage"
            solo
            dense
            hide-details
            class="pia-input"
            placeholder="Digite sua dúvida..."
            aria-label="Digite sua dúvida"
          />
          <v-btn icon type="submit" color="#167ABC" aria-label="Enviar mensagem" :disabled="!draftMessage.trim()">
            <v-icon>mdi-send</v-icon>
          </v-btn>
        </form>
      </div>
    </v-card>

    <div v-else class="pia-launcher-wrap">
      <div class="pia-help-label">Preciso de Ajuda</div>
      <v-btn fab large color="#EFC00F" class="pia-launcher" type="button" aria-label="Abrir chat da PIA" @click="openChat">
        <div class="pia-avatar" aria-hidden="true"><img src="../../assets/logo-pia.png" alt="" class="pia-logo"></div>
        <span v-if="unreadCount" class="pia-unread">{{ unreadCount }}</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PIAChatbot',
  data() {
    return {
      chatbotOpen: false,
      currentView: 'menu',
      draftMessage: '',
      unreadCount: 1,
      nextMessageId: 3,
      menuOptions: [
        { label: 'Cadastrar como fornecedor', action: 'supplier' },
        { label: 'Cadastrar como comprador', action: 'buyer' },
        { label: 'Entender os perfis de acesso', action: 'profiles' },
        { label: 'Primeiro acesso ou recuperar senha', action: 'password' },
        { label: 'Falar com o suporte', action: 'support' }
      ],
      messages: [
        { id: 1, sender: 'pia', paragraphs: ['Olá! Eu sou o PIA 👋', 'Como posso ajudar você a acessar o PetroSupply?'] },
        { id: 2, sender: 'pia', actions: [
          { label: 'Cadastrar como fornecedor', action: 'supplier' },
          { label: 'Cadastrar como comprador', action: 'buyer' },
          { label: 'Entender os perfis de acesso', action: 'profiles' },
          { label: 'Primeiro acesso ou recuperar senha', action: 'password' },
          { label: 'Falar com o suporte', action: 'support' }
        ] }
      ]
    };
  },
  methods: {
    openChat() {
      this.chatbotOpen = true;
      this.unreadCount = 0;
      this.scrollToBottom();
    },
    closeChat() { this.chatbotOpen = false; },
    addMessage(message) {
      this.messages.push({ id: this.nextMessageId++, ...message });
      this.scrollToBottom();
    },
    selectView(view, label) {
      this.addMessage({ sender: 'user', paragraphs: [label] });
      this.currentView = view;
      this.addMessage({ sender: 'pia', ...this.responses[view] });
    },
    runAction(action) {
      if (this[action]) { this[action](); return; }
      const option = this.menuOptions.find(item => item.action === action);
      if (option) this.selectView(action, option.label);
    },
    backToMenu() {
      this.currentView = 'menu';
      this.addMessage({ sender: 'pia', paragraphs: ['Claro! Como posso ajudar?'], actions: this.menuOptions });
    },
    demoAction(label) {
      this.addMessage({ sender: 'user', paragraphs: [label] });
      this.addMessage({ sender: 'pia', paragraphs: ['Esta ação está disponível apenas como demonstração neste protótipo.'] });
    },
    sendMessage() {
      const text = this.draftMessage.trim();
      if (!text) return;
      this.addMessage({ sender: 'user', paragraphs: [text] });
      this.draftMessage = '';
      this.addMessage({ sender: 'pia', paragraphs: ['Ainda estou em fase de protótipo. Para essa dúvida, consulte uma das opções de suporte acima.'] });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.messages) this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;
      });
    },
    supplier() { this.selectView('supplier', 'Cadastrar como fornecedor'); },
    buyer() { this.selectView('buyer', 'Cadastrar como comprador'); },
    profiles() { this.selectView('profiles', 'Entender os perfis de acesso'); },
    password() { this.selectView('password', 'Primeiro acesso ou recuperar senha'); },
    support() { this.selectView('support', 'Falar com o suporte'); },
    firstAccess() { this.demoAction('Fazer o primeiro acesso'); },
    recoverPassword() { this.demoAction('Recuperar minha senha'); },
    emailNotReceived() { this.demoAction('Não recebi o e-mail'); },
    accessSupport() { this.demoAction('Acessar o suporte'); },
    demoSupplier() { this.demoAction('Iniciar cadastro de fornecedor'); },
    demoBuyer() { this.demoAction('Iniciar cadastro de comprador'); },
    returnMenu() { this.backToMenu(); }
  },
  computed: {
    responses() {
      const menuAction = { label: 'VOLTAR AO MENU', action: 'returnMenu' };
      return {
        supplier: {
          title: 'Cadastro de fornecedor',
          paragraphs: ['O perfil Fornecedor é destinado a empresas que oferecem produtos ou serviços para a cadeia de óleo e gás.'],
          list: ['Dados da empresa', 'CNPJ e contatos', 'Informações do responsável'],
          actions: [{ label: 'INICIAR CADASTRO', action: 'demoSupplier' }, menuAction],
          alert: 'Se encontrar alguma dificuldade, fale com o suporte.'
        },
        buyer: {
          title: 'Cadastro de comprador',
          paragraphs: ['O perfil Comprador é destinado a empresas ou instituições que buscam fornecedores, produtos ou serviços na cadeia de óleo e gás.'],
          list: ['Dados da organização', 'CNPJ e contatos', 'Informações do responsável'],
          actions: [{ label: 'INICIAR CADASTRO', action: 'demoBuyer' }, menuAction],
          alert: 'Se encontrar alguma dificuldade, fale com o suporte.'
        },
        profiles: {
          title: 'Perfis de acesso',
          paragraphs: ['Usuário: acessa a conta pessoal e as funcionalidades liberadas para seu perfil.', 'Fornecedor: apresenta produtos e serviços para oportunidades de negócio.', 'Comprador: busca fornecedores, produtos e serviços para sua organização.'],
          actions: [menuAction]
        },
        password: {
          title: 'Como podemos ajudar?',
          paragraphs: ['Escolha uma das opções abaixo:'],
          actions: [
            { label: 'FAZER O PRIMEIRO ACESSO', action: 'firstAccess' },
            { label: 'RECUPERAR MINHA SENHA', action: 'recoverPassword' },
            { label: 'NÃO RECEBI O E-MAIL', action: 'emailNotReceived' },
            menuAction
          ],
          alert: 'A PIA não solicita senha, token ou código recebido por e-mail.'
        },
        support: {
          title: 'Atendimento do suporte',
          paragraphs: ['Se a PIA não conseguiu resolver sua dúvida, entre em contato pelo canal oficial de suporte.'],
          list: ['CANAL OFICIAL', 'Central de Suporte PetroSupply'],
          actions: [{ label: 'ACESSAR O SUPORTE', action: 'accessSupport' }, menuAction],
          alert: 'Nunca envie senhas, códigos de acesso ou documentos sensíveis.'
        }
      };
    }
  }
};
</script>

<style scoped>
.pia-chatbot { position: fixed; right: 24px; bottom: 24px; z-index: 20; font-family: Roboto, sans-serif; }
.pia-window { width: 360px; height: min(600px, calc(100vh - 48px)); display: flex; flex-direction: column; overflow: hidden; border-radius: 16px; box-shadow: 0 12px 36px rgba(8, 49, 82, .3) !important; }
.pia-header { min-height: 76px; padding: 13px 12px 13px 16px; display: flex; align-items: center; justify-content: space-between; color: #fff; background: #167ABC; }
.pia-identity { display: flex; align-items: center; min-width: 0; gap: 10px; }
.pia-identity strong, .pia-identity small { display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pia-identity small { margin-top: 3px; font-size: 10px; opacity: .85; }
.pia-online-dot { display: inline-block; width: 8px; height: 8px; margin-left: 3px; border-radius: 50%; background: #53d477; vertical-align: middle; }
.pia-avatar { width: 54px; height: 54px; display: grid; place-items: center; border-radius: 50%; background: #fff; box-shadow: 0 3px 8px rgba(0, 0, 0, .18); }
.pia-avatar--header { width: 42px; height: 42px; }
.pia-logo { width: 100%; height: 100%; border-radius: 50%; object-fit: cover; }
.pia-header-actions { display: flex; flex-shrink: 0; }
.pia-messages { flex: 1; min-height: 0; padding: 16px 12px; overflow-y: auto; background: #f4f7f9; }
.pia-message-row { display: flex; margin-bottom: 12px; }
.pia-message-row--user { justify-content: flex-end; }
.pia-message { max-width: 91%; padding: 11px 13px; border-radius: 13px 13px 13px 3px; color: #30404b; background: #fff; font-size: 13px; line-height: 1.45; box-shadow: 0 1px 3px rgba(15, 44, 63, .09); }
.pia-message--user { border-radius: 13px 13px 3px 13px; color: #fff; background: #167ABC; }
.pia-message p { margin: 0 0 8px; }
.pia-message p:last-child { margin-bottom: 0; }
.pia-message-title { display: block; margin-bottom: 8px; color: #167ABC; font-size: 14px; }
.pia-message-list { margin: 5px 0 10px; padding-left: 19px; }
.pia-alert { margin-top: 10px; padding: 8px; border-radius: 6px; color: #725600; background: #fff4c9; font-size: 11px; }
.pia-actions { display: flex; flex-direction: column; gap: 6px; margin-top: 10px; }
.pia-action { justify-content: flex-start; min-height: 32px !important; padding: 0 10px !important; color: #167ABC !important; border-color: #9cc9e5 !important; font-size: 11px !important; }
.pia-composer { padding: 8px 12px 10px; background: #fff; border-top: 1px solid #e1e8ed; }
.pia-security-note { margin-bottom: 5px; color: #60717d; font-size: 10px; text-align: center; }
.pia-input-row { display: flex; align-items: center; gap: 4px; }
.pia-input { min-width: 0; }
.pia-launcher-wrap { display: flex; align-items: center; gap: 10px; }
.pia-help-label { padding: 8px 12px; border-radius: 8px; color: #164763; background: #fff; font-size: 13px; font-weight: 600; box-shadow: 0 3px 12px rgba(8, 49, 82, .18); }
.pia-launcher { position: relative; box-shadow: 0 5px 15px rgba(8, 49, 82, .3) !important; }
.pia-unread { position: absolute; top: -3px; right: -3px; width: 20px; height: 20px; border: 2px solid #fff; border-radius: 50%; color: #fff; background: #d83b3b; font-size: 11px; line-height: 16px; }
@media (max-width: 600px) {
  .pia-chatbot { right: 12px; bottom: 12px; left: 12px; }
  .pia-window { width: 100%; height: min(600px, calc(100vh - 24px)); }
  .pia-launcher-wrap { justify-content: flex-end; }
}
</style>